module.exports = __webpack_public_path__ + "assets/img/trust_1.6d15752e.png";